module.exports = __webpack_public_path__ + "phone_bg_clear-9ff91e45d998e906b127eb9ee0d82176.png";